<h1 class="accent-background-element">Review Transfer Patient to another Clinic</h1>

<mat-dialog-content>
    <h3 class="warn-text-element">Are you sure you want to transfer the Patient to another Clinic? 
    </h3>
    <br>

    <h3>Patient ID:&nbsp;<span class="not-bold">{{currentPatient?.patientId}}</span></h3>
    <h3>Full Name: &nbsp;<span class="not-bold">{{currentPatient?.firstName}} {{currentPatient?.lastName}}</span></h3>
    <h3>E-mail:&nbsp; <span class="not-bold">{{currentPatient?.email}}</span></h3>
    <h3>Previous shop ID: &nbsp;<span class="not-bold">{{currentPatient?.shopId}}</span></h3>
    <h3>Previous shop Details: &nbsp;<span class="not-bold">{{[currentPatient?.shopName,currentPatient?.shopAddress].join(", ")}}</span></h3>
    <br>
    <h3 class="warn-text-element">New shop ID: &nbsp;<span class="not-bold">{{newPatientShop?.shopId}}</span></h3>
    <h3 class="warn-text-element">New shop Details: &nbsp;<span class="not-bold">{{[newPatientShop?.shopName,newPatientShop?.addressLine1,newPatientShop?.addressLine2].join(", ")}}</span></h3>
   
    <p class="mat-caption warn-text-element ">Warning: You are about to change the Tinnitus Clinic. This will remove the patient from this Tinnitus Clinic and transfer all data to the selected clinic.</p>

</mat-dialog-content>

<mat-dialog-actions>
    <button mat-raised-button color="accent" (click)="exit()">Go back and edit</button>
    <span class="spacer"></span>
    <button mat-raised-button color="warn" (click)="onSubmit()">Confirm transfer</button>
</mat-dialog-actions>

<ng-template #none>
    <mat-icon svgIcon='dash'></mat-icon>
</ng-template>